// pages/Personal Attendance/DeptFtos.js
//
// Legacy menu items (single page, future-toggle in toolbar):
//   "Show All FTO's of my Dept"     → defaultFuture = false
//   "Show Future FTO's of my Dept"  → defaultFuture = true (route param)
//
// Backend: GET /api/fto/dept[?future=true]

import React from "react";
import { useLocation } from "react-router-dom";
import DeptAttendanceTable from "./components/DeptAttendanceTable";
import { getFtoDept } from "./ftoService";

const DeptFtos = () => {
    // /attendance/dept/fto?future=1 (or just /attendance/dept/fto)
    const loc = useLocation();
    const futureDefault = new URLSearchParams(loc.search).get("future") === "1";

    return (
        <DeptAttendanceTable
            title={futureDefault ? "Future FTOs of My Dept" : "All FTOs of My Dept"}
            subtitle="FTOs from you and your direct reports"
            kind="FTO"
            fetcher={getFtoDept}
            defaultFuture={futureDefault}
            breadcrumb={[{ label: "Attendance", to: "/workflows?wf=pac" }, { label: "Dept FTOs" }]}
        />
    );
};

export default DeptFtos;
